/*global angular*/
/*global _*/

angular.module('clinkManager')
.controller('SummaryCtrl', ['$scope', 'summary', '$uibModalInstance', function ($scope, summary, $uibModalInstance) {

	$scope.summary = summary;

	$scope.init = function() {
		$scope.summary = [];
		var keys = _.keys( summary );
		for( var i=0; i<keys.length; i++ ) {
			$scope.summary.push( summary[keys[i]] );
		}
	};

	$scope.sort = {
		comparison : 'pubName',
		reverse    : false
	};

	$scope.cancel = function () {
	  	$uibModalInstance.dismiss('cancel');
  	};

  	$scope.sortBy = function( property ) {
		if( $scope.lastSortedProperty === property ) {
			$scope.sort.reverse = !$scope.sort.reverse;
		}
		$scope.lastSortedProperty = property;
		$scope.sort.comparison = property;
	};
}]);
	